import { Component, EventEmitter, Input, OnInit, Output} from '@angular/core';

@Component({
    selector: 'consultant-gdpr-dialog',
    templateUrl: 'consultant-gdpr-dialog.html',
    styleUrls: ['./consultant-gdpr-dialog.scss']
})
export class ConsultantGdprDialog implements OnInit {
    @Input() showMe: boolean = false;
    @Output() onCloseDlg = new EventEmitter<any>();
  
    consNumber: string = '';

    constructor() { }

    ngOnInit() {

    }

    closeDialog(isGetData: boolean) {
        this.onCloseDlg.emit(isGetData ? this.consNumber.trim() : '');

        this.showMe = false;
    }
}
